var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isMealComponentLoadDone
    ? _c("loading-indicator", { attrs: { "is-full-page": true } })
    : _vm.mealComponent !== null
    ? _c(
        "div",
        { staticClass: "container" },
        [
          _c("div", { staticClass: "meal-component my-5" }, [
            _c("div", [
              _c("div", { staticClass: "text-center header-row py-2" }, [
                _c("h2", {
                  staticClass: "text-center",
                  domProps: { innerHTML: _vm._s(_vm.mealComponent.name) }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "data-row d-flex flex-wrap py-2" }, [
                _c("div", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "kaloszlist_feherje",
                      expression: "'kaloszlist_feherje'"
                    }
                  ],
                  staticClass: "col-8"
                }),
                _vm._v(" "),
                _c("div", { staticClass: "col-4" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.mealComponent.data.protein) +
                      " " +
                      _vm._s(
                        _vm.mealComponent.chartData.weight.datasets[0].unit
                      ) +
                      "\n        "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "data-row d-flex flex-wrap py-2" }, [
                _c("div", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "kaloszlist_szenhidrat",
                      expression: "'kaloszlist_szenhidrat'"
                    }
                  ],
                  staticClass: "col-8"
                }),
                _vm._v(" "),
                _c("div", { staticClass: "col-4" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.mealComponent.data.carbohydrate) +
                      " " +
                      _vm._s(
                        _vm.mealComponent.chartData.weight.datasets[0].unit
                      ) +
                      "\n        "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "data-row d-flex flex-wrap py-2" }, [
                _c("div", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "kaloszlist_zsir",
                      expression: "'kaloszlist_zsir'"
                    }
                  ],
                  staticClass: "col-8"
                }),
                _vm._v(" "),
                _c("div", { staticClass: "col-4" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.mealComponent.data.fat) +
                      " " +
                      _vm._s(
                        _vm.mealComponent.chartData.weight.datasets[0].unit
                      ) +
                      "\n        "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "data-row d-flex flex-wrap py-2" }, [
                _c("div", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "kaloszlist_viz",
                      expression: "'kaloszlist_viz'"
                    }
                  ],
                  staticClass: "col-8"
                }),
                _vm._v(" "),
                _c("div", { staticClass: "col-4" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.mealComponent.data.water) +
                      " " +
                      _vm._s(
                        _vm.mealComponent.chartData.weight.datasets[0].unit
                      ) +
                      "\n        "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "data-row d-flex flex-wrap py-2" }, [
                _c("div", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "kaloszlist_energia",
                      expression: "'kaloszlist_energia'"
                    }
                  ],
                  staticClass: "col-8"
                }),
                _vm._v(" "),
                _c("div", { staticClass: "col-4" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.mealComponent.data.calorie) +
                      " " +
                      _vm._s(
                        _vm.mealComponent.chartData.weight.datasets[0].unit
                      ) +
                      "\n        "
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.mealComponent.data.isBodyBuilder
                ? _c("div", { staticClass: "data-row d-flex flex-wrap py-2" }, [
                    _c("div", { staticClass: "col-8" }, [
                      _c("i", { staticClass: "fas fa-child" }),
                      _vm._v(" "),
                      _c("span", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "kaloszlist_testepito",
                            expression: "'kaloszlist_testepito'"
                          }
                        ]
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-4" })
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-flex flex-wrap justify-content-around chart-row"
              },
              [
                _c("pie-chart-block", {
                  attrs: {
                    "chart-title": _vm.$t("kaloszlist_graf_sulyeloszlas"),
                    "chart-data": _vm.mealComponent.chartData.weight
                  }
                }),
                _vm._v(" "),
                _c("pie-chart-block", {
                  attrs: {
                    "chart-title": _vm.$t("kaloszlist_graf_energiaeloszlas"),
                    "chart-data": _vm.mealComponent.chartData.energy
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.mealComponent.productListContainsComponent.length !== 0
            ? _c("candy-bar", {
                staticClass: "my-3",
                attrs: {
                  title: _vm.$t("kaloszlist_termekek"),
                  "product-list": _vm.mealComponent.productListContainsComponent
                }
              })
            : _vm._e()
        ],
        1
      )
    : _c("div", {
        directives: [
          {
            name: "t",
            rawName: "v-t",
            value: "nincs_megjelenitheto_tartalom",
            expression: "'nincs_megjelenitheto_tartalom'"
          }
        ],
        staticClass: "text-center my-5 container"
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }